import Icon from "../../../../../assets/spaceicons/input.svg";
import {
  SpaceComponentPackage,
  SpaceComponentHostType,
  SpaceComponentTags
} from "../../../../../types";
import { DEFAULT_SIZES } from "../../../layout/constants";
import { ElementLayout } from "../../../layout/util";

import Config, { InlineConfig, TerseConfig } from "./Config";
import errorSelector from "./Config/errorSelector";
import componentConfigReducer, {
  ensureCustomFieldComponent,
  getComponentProperties,
  makeInitialState
} from "./Config/reducer";
import { getSchema } from "./getSchema";
import SpaceCustomField from "./SpaceCustomField";
import {
  SpaceCustomFieldComponent,
  CustomFieldConfigState,
  SpaceCustomFieldProperties
} from "./types";

const pkg: SpaceComponentPackage<
  SpaceCustomFieldProperties,
  SpaceCustomFieldComponent,
  CustomFieldConfigState
> = {
  type: "CUSTOM_FIELD",
  displayName: "Input",
  Icon,
  allowedHosts: new Set<SpaceComponentHostType>([
    "HEADER",
    "FLEX_BOX",
    "TABLE",
    "DETAIL",
    "CARD_LIST",
    "FUNCTION_FORM",
    "FUNCTION_MODAL_FORM",
    "CLOUD_UPLOADER"
  ]),
  Component: SpaceCustomField,
  ConfigurationComponent: Config,
  TerseConfigurationComponent: TerseConfig,
  InlineConfigurationComponent: InlineConfig,
  componentConfigReducer,
  getInitialDraftState: makeInitialState,
  ensureComponent: ensureCustomFieldComponent,
  getComponentProperties,
  getSchema,
  defaultElementLayout: new ElementLayout({
    width: DEFAULT_SIZES.INPUT.width,
    height: DEFAULT_SIZES.INPUT.height,
    snapToGrid: false
  }),
  fallbackWidth: 178,
  allowSelfBinding: true,
  allowAncestorBinding: true,
  tags: [SpaceComponentTags.Input],
  isHeadless: false,
  errorSelector,
  isContainer: false
};

export default pkg;
